import { useMemo } from 'react';

import type { TRootElement } from '@shared/dream-components';
import { RENDERABLE_NODE_KEYS_IN_PAGE_DATA } from '@shared/dream-components';

import type { NodeContent, Page } from '~/interfaces/page';
import type { Site, SiteVersion } from '~/interfaces/site';

import { serializeNode } from './nodes/serializeNode';

interface Props {
  page?: Page;
  site: Site;
}

const RENDERABLE_NODE_KEYS_IN_SITE: string[] = ['signup_modal', 'recommendations_modal', 'login_modal'];

const GlobalElementsSerializer = ({ page, site }: Props) => {
  const renderableNodes: NodeContent[] = useMemo(
    () => [
      ...RENDERABLE_NODE_KEYS_IN_SITE.map(
        (nodeKey: string) => site.viewable_site_version[nodeKey as keyof SiteVersion] as NodeContent,
      ).filter(Boolean),
      ...(RENDERABLE_NODE_KEYS_IN_PAGE_DATA.map((nodeKey: string) => {
        if (page?.viewable_page_version?.content) {
          const node = (page.viewable_page_version.content as TRootElement)?.attrs?.data?.[nodeKey] as NodeContent;
          if (node && 'type' in node && node.type === 'doc' && node.content.length > 0) {
            return node.content[0];
          }
        }

        return null;
      }).filter(Boolean) as NodeContent[]),
    ],
    [site, page],
  );

  if (renderableNodes.length > 0) {
    return serializeNode(renderableNodes, '!min-h-0');
  }

  return null;
};

export default GlobalElementsSerializer;
